import { render, staticRenderFns } from "./RunnerStartsColumns.vue?vue&type=template&id=3837dcee&scoped=true&"
import script from "./RunnerStartsColumns.vue?vue&type=script&lang=js&"
export * from "./RunnerStartsColumns.vue?vue&type=script&lang=js&"
import style0 from "./RunnerStartsColumns.vue?vue&type=style&index=0&id=3837dcee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837dcee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
